<script>
    import {RideLevels} from '@js/components/modules/constants';
    import I18n from '@js/modules/translations';
    import {activateOnKey} from '@js/modules/a11y';

    import Dropdown from '@js/components/themes/Dropdown.svelte';

    const {
        name,
        label = I18n.t('js.ride.model.level'),
        defaultValue = RideLevels[0],
        onLevelChange
    } = $props();

    let rideLevel = $state(defaultValue);

    let _pickedByUser = false;

    const _handleLevelChange = (level, event) => {
        event.preventDefault();

        _pickedByUser = true;
        rideLevel = level;

        if (onLevelChange) {
            onLevelChange(level);
        }
    };

    $effect(() => {
        // Reads defaultValue only, so it re-runs when the prop changes — never because
        // rideLevel did.
        const incoming = defaultValue;

        if (_pickedByUser) {
            return;
        }

        rideLevel = incoming;
    });
</script>

<Dropdown label={label}
          class="mx-auto w-full"
          buttonClass="w-full px-4 py-2 flex justify-between rounded-lg text-sm"
          color="gray"
          name={name}
          selected={rideLevel}
          optionSize={RideLevels.length}
          closeClickInside={true}>
    {#snippet dropdownButtonRender()}
    <span class="flex items-center justify-center">
        {I18n.t(`js.ride.enums.level.${rideLevel}`)}
    </span>
    {/snippet}

    <ul class="text-sm text-gray-700 dark:text-gray-200"
        role="listbox"
        aria-labelledby="RouteLevel">
        {#each RideLevels as level (level)}
            <li class="flex items-center justify-start p-2 cursor-pointer hover:bg-gray-300"
                class:bg-primary-200={rideLevel === level}
                role="option"
                aria-selected={rideLevel === level}
                tabindex="0"
                onclick={_handleLevelChange.bind(null, level)}
                onkeydown={activateOnKey(_handleLevelChange.bind(null, level))}>
                {I18n.t(`js.ride.enums.level.${level}`)}
            </li>
        {/each}
    </ul>
</Dropdown>
